<template>
  <div class="good-info-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="btn" @click="handleAddModal('add')">+ 新增</div>

        <el-table
          :data="customFields"
          class="order-table table no-border-table"
          ref="orderTable"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column
            prop="name"
            align="center"
            label="参数名称"
          ></el-table-column>
          <el-table-column
            prop="type"
            align="center"
            label="类型"
          ></el-table-column>
          <el-table-column
            prop="value"
            align="center"
            label="参数值"
          ></el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <div slot-scope="scope" style="display: flex">
              <div>
                <button
                  size="mini"
                  class="table-btn"
                  @click="handleAddModal('edit', scope.row, scope.$index)"
                >
                  编辑
                </button>
              </div>
              <div>
                <button
                  size="mini"
                  class="table-btn"
                  @click="handleDelete(scope.$index)"
                >
                  删除
                </button>
              </div>
            </div>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :visible.sync="visible" class="dialog" width="400px" top="25vh">
      <div slot="title" class="dialog-title">
        {{ type === "add" ? "新建" : "编辑" }}
      </div>
      <el-form
        ref="form"
        :model="addForm"
        class="form"
        label-width="auto"
        style="padding-left: 32px;"
      >
        <el-form-item label="参数名称:" prop="name" class="form-item">
          <el-input
            size="small"
            placeholder="请输入参数名称"
            class="add-renovation-input"
            style="width: 200px"
            v-model="addForm.name"
          ></el-input>
        </el-form-item>
        <el-form-item label="类型:" prop="classifyName" class="form-item">
          <el-radio-group v-model="addForm.type">
            <el-radio label="数字">数字</el-radio>
            <el-radio label="字符串">字符串</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="参数值:" prop="value" class="form-item">
          <el-input
            size="small"
            placeholder="请输入参数值"
            class="add-renovation-input"
            style="width: 200px"
            v-model="addForm.value"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="visible = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="handleAdd">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
export default {
  components: { Header },
  name: 'goods-lock',
  data() {
    return {
      loading: 0,
      title: {
        // 页面标题
        firstTitile: '产品管理',
        secondTitle: 'AI参数设置'
      },
      id: null,
      baseInfo: {
        name: '',
        brand: null,
        series: null,
        masterPic: '',
        price: null,
        status: null,

        milkVersion: null,  // 奶粉版本
        milkSource: null, // 奶源地
        milkOrigin: null, // 产地
        milkCategory: null, // 类别
        milkSpecification: null,  //规格
        milkRecommendedAge: null, //适用年龄

        ingredientList: '', // 配料表
        milkReview: '', // 奶粉点评
        sourceReview: '',// 奶源点评
        materialReview: '',// 原料点评
        milkStage: '', //段位

        manufacturer: '', // 厂家
        regNo: '', // 注册号
        serviceProvider: '', // 运营商

        ingredientUnit: '',

        advantage: '',
        nutritionalAnalysisNormal: '',
        nutritionalAnalysisFortify: '',

        ingredientTable: [],
        summary: ''
      },
      customFields: [],
      visible: false,
      type: '',
      addForm: {},
      index: null
    };
  },
  computed: {},
  async mounted() {
    let query = this.$route.query;
    if (query && query.id) {
      this.id = query.id;
      this.getGoodDetail(query.id);
    }
  },
  methods: {
    // 获取产品信息
    getGoodDetail(id) {
      this.loading++;
      this.httpGet(this.$root.getGoodInfo, { id }).then(
        (res) => {
          this.loading--;
          let baseInfo = { ...this.baseInfo };
          for (let key in baseInfo) {
            baseInfo[key] = res[key];
          }
          this.baseInfo = { ...baseInfo };
          this.id = res.id;
          this.customFields = res.customFields || [];
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    handleAddModal(type, rowData, index = null) {
      this.type = type;
      if (type === 'edit') {
        this.addForm = {
          name: rowData.name,
          type: rowData.type,
          value: rowData.value,
        };
        this.index = index;
      } else {
        this.addForm = {
            name: '',
            type: '',
            value: '',
        };
      }
      this.visible = true;
    },
    handleAdd(){
        if(this.type === 'edit'){
            !isNaN(this.index) && this.customFields.splice(this.index, 1, this.addForm);
        } else {
            this.customFields.push(this.addForm);
        }
      this.visible = false;
      this.handleConfirm();
    },
    handleDelete(index) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要删除该参数吗？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.customFields.splice(index, 1);
        this.handleConfirm();
      });
    },
    handleConfirm(){
      this.loading++;
      this.httpPut(this.$root.updateGood, {
        id: this.id,
        ...this.baseInfo,
        customFields: this.customFields
      }).then(
        (res) => {
          this.$message({
            message: '产品参数修改成功',
            type: 'success'
          });
          this.loading--;
          this.getGoodDetail(this.id);
        //   this.$router.push({
        //     name: 'goodsManage'
        //   });
        },
        (res) => {
          this.loading--;
          this.getGoodDetail(this.id);
          this.$message.error(res);
        }
      );
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.good-info-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 0 20px 20px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;
      // 按钮
      .btn {
          // width: 100px;
          display: inline-block;
          padding: 0 30px;
          height: 32px;
          line-height: 32px;
          confirm-btn();
          font-size: 14px;
          margin-bottom: 16px;
          // margin: 16px 0;
      }
      // 表格按钮
      .table-btn {
        width: 65px;
        height: 24px;
        line-height: 24px;
        color: gray3;
        font-size: 12px;
        margin-right: 8px;
        cancel-btn();
      }

    }
  }

  .btn-box {
    background: white;
    width: 100%;
    flex-x(center);
    height: 100px !important;
    flex-shrink: 0;
    // padding-bottom: 48px;

    .cancel-btn {
      width: 96px;
      height: 40px;
      cancel-btn();
      // border-radius: 23px;
    }

    .confirm-btn {
      width: 96px;
      height: 40px;
      margin-left: 20px;
      confirm-btn();
    }
  }
}
</style>
